import { handlers, config } from '_helpers';
import crFetch from '_helpers/fetch';

const { handleResponseAsync } = handlers;
const API = config.apiUrl.v1API;

async function getMostRecent(numberToRetrieve) {
  return handleResponseAsync(
    await (
      crFetch({
        method: 'GET',
        url: `/InboundEmailLogs${numberToRetrieve ? `?numberToRetrieve=${numberToRetrieve}` : ''}`
      }, API))
  );
}

const inboundEmailLogService = {
  getMostRecent,
};

export default inboundEmailLogService;
